import {CognitoUserPool, CognitoUser, CognitoUserAttribute} from "amazon-cognito-identity-js";

const poolData = {
    UserPoolId: "us-east-1_af2GRumEQ",
    ClientId: "28qrq8nr4tih8odvf11ufs1a9s",
};

const userPool = new CognitoUserPool(poolData);

class RegisterService {

    async registerUser(
        username: string,
        password: string,
        email: string,
        phoneNumber: string
    ): Promise<string> {
        const attributeList: CognitoUserAttribute[] = [];

        const attributeEmail = new CognitoUserAttribute({Name: "email", Value: email});
        const attributePhoneNumber = new CognitoUserAttribute({Name: "phone_number", Value: phoneNumber});

        attributeList.push(attributeEmail, attributePhoneNumber);

        return new Promise((resolve, reject) => {
            userPool.signUp(username, password, attributeList, [], (err, result) => {
                if (err) {
                    reject(err.message || JSON.stringify(err));
                } else if (result?.user) {
                    resolve(result.user.getUsername());
                }
            });
        });
    }

  async confirmUser(username: string, confirmationCode: string): Promise<string> {
    const userData = { Username: username, Pool: userPool };
    const cognitoUser = new CognitoUser(userData);

    return new Promise((resolve, reject) => {
      cognitoUser.confirmRegistration(confirmationCode, true, (err, result) => {
        if (err) {
          reject(err.message || JSON.stringify(err));
        } else {
          resolve(result);
        }
      });
    });
  }

  async resendConfirmationCode(username: string): Promise<string> {
    const userData = { Username: username, Pool: userPool };
    const cognitoUser = new CognitoUser(userData);

    return new Promise((resolve, reject) => {
      cognitoUser.resendConfirmationCode((err, result) => {
        if (err) {
          reject(err.message || JSON.stringify(err));
        } else {
          resolve(result);
        }
      });
    });
  }
}

export default new RegisterService();